module.exports = __webpack_public_path__ + "img/zip-icon.d5052537.svg";